import { setMonth as a } from "./setMonth.js";
import { toDate as f } from "./toDate.js";
function c(o, r) {
  const t = f(o), e = Math.trunc(t.getMonth() / 3) + 1, n = r - e;
  return a(t, t.getMonth() + n * 3);
}
export {
  c as default,
  c as setQuarter
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/date-fns@3.6.0/~/date-fns/setQuarter.js
// module id = 1443
// module chunks = 67